import { render, staticRenderFns } from "./HiddenFieldsEditor.vue?vue&type=template&id=b0e480be&scoped=true"
import script from "./HiddenFieldsEditor.vue?vue&type=script&lang=js"
export * from "./HiddenFieldsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e480be",
  null
  
)

export default component.exports